import React from "react";
import Box from "@mui/material/Box";
import { DefaultLabel } from "@assets/label";
import { OutlinedInputDefault } from "@assets/TextField";
import { priceResult, nulltoZero } from "@assets/utils/check";

const ImpressionsCpp = ({
  cpm_limit,
  is_cpm,
  cpm_current,
  view_count,
  click_count,
  onChange,
}) => {
  const viewCount = nulltoZero(view_count);
  const clickCount = nulltoZero(click_count);
  const clickPer = (nulltoZero(clickCount / viewCount) * 100).toFixed(2) + "%";

  return (
    <>
      <Box sx={{ mb: 3, width: "49%" }}>
        <DefaultLabel name="노출 수" />
        <OutlinedInputDefault
          value={viewCount}
          disabled={true}
          inputType="text"
          // onChange={(e) => onChange(e)}
          name={"view_count"}
          krName={"노출 수"}
        />
      </Box>
      <Box sx={{ mb: 3, width: "49%" }}>
        <DefaultLabel name="클릭수" />
        <OutlinedInputDefault
          value={clickCount ? priceResult(clickCount) : "-"}
          disabled={true}
          inputType="text"
          name={"click_count"}
          krName={"클릭수"}
        />
      </Box>
      <Box sx={{ mb: 3, width: "100%" }}>
        <DefaultLabel name="클릭률" />
        <OutlinedInputDefault
          value={clickPer}
          disabled={true}
          inputType="text"
          name={"click_per"}
          krName={"클릭률"}
        />
      </Box>
    </>
  );
};

export default ImpressionsCpp;
